import {createRouter, createWebHashHistory} from 'vue-router';
import DocsMain from '@components/docs/DocsMain.vue';
import ServicesMain from '@components/services/ServicesMain.vue';
import ReportsMain from '@components/reports/ReportsMain.vue';
import SettingsMain from '@components/settings/SettingsMain.vue';
import STATReport from "@components/reports/STAT.vue";
import KpiReportReport from "@components/reports/KPI/KPIReport.vue";
import EODReport from "@components/reports/EOD/EODReport.vue";
import EodPage from "@components/reports/EOD/EODPage.vue";

const routes = [
    {
        path: '/',
        redirect: '/docs'
    },
    {
        path: '/docs',
        name: 'docs',
        component: DocsMain
    },
    {
        path: '/services',
        name: 'services',
        component: ServicesMain
    },
    {
        path: '/reports',
        name: 'reports',
        redirect: '/reports/eod',
        component: ReportsMain,
        children: [
            {
                path: 'stat',
                name: 'reports-stat',
                component: STATReport
            },
            {
                path: 'kpi',
                name: 'reports-kpi',
                component: KpiReportReport
            },
            {
                path: 'eod',
                name: 'reports-eod',
                component: EodPage,
                redirect: '/reports/eod/today',
                children: [
                    {
                        path: 'today',
                        name: 'employee-eod',
                        component: EODReport
                    },
                    {
                        path: ':shopId/:date',
                        name: 'manager-eod-report',
                        component: EODReport,
                    }
                ]
            }
        ]
    },
    {
        path: '/settings',
        name: 'settings',
        component: SettingsMain
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router;